<div *ngIf="showBanner"
	 class="w-screen py-4 px-2 flex justify-center  flex-wrap items-center bg-[#655643] fixed bottom-0 gap-5 z-50">
	<p class="text-white text-sm text-center">
		We use cookies to offer you a better experience, we store no personal details.
		By continuing to use this website, you accept our <a target="_blank" href="https://anuprerna.com/content/policies/privacy-policy/173823" class="underline">policies</a>
	</p>
	<button (click)="accept()" class="px-4 py-1 bg-white rounded text-[#655643] text-sm">Accept</button>
</div>
